/**
 * Who a chat prompt is for, from the user's effective capabilities.
 *
 * Internal means 3PH staff: `context:3ph_internal`, which only the `internal`
 * role carries (platform admins pass through `*`). Anyone without it gets the
 * external `<organization>` block, so an account nobody has classified sees
 * less, never more. Resolve from the *effective* capabilities so an admin's
 * impersonation preview shows exactly what the impersonated user would get.
 */

import { hasCapability } from '@/lib/rbac/has-capability'
import { orgNameFromCaps } from '@/lib/rbac/organizations'
import { INTERNAL_CONTEXT_CAP } from '@/lib/rbac/roles'

import type { PromptAudience } from './identity'

export function resolvePromptAudience(caps: readonly string[]): PromptAudience {
  const internal = hasCapability(caps, INTERNAL_CONTEXT_CAP)
  return {
    internal,
    orgName: internal ? undefined : orgNameFromCaps(caps),
    caps,
  }
}
